import React from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import { withTheme } from 'styled-components';
import './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import './box-e581bc98.js';
import { I as IconWrapper, g as getObjectValue } from './IconWrapper-f69d60c7-8a74d4d9.js';
import '@styled-system/grid';
import '@styled-system/background';
import './index.esm-f8e9e79f-5619e21b.js';

var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.41842 6.43934C2.97631 5.85355 3.88083 5.85355 4.43872 6.43934L12 14.3787L19.5613 6.43934C20.1192 5.85355 21.0237 5.85355 21.5816 6.43934C22.1395 7.02513 22.1395 7.97487 21.5816 8.56066L13.0102 17.5607C12.4523 18.1464 11.5477 18.1464 10.9898 17.5607L2.41842 8.56066C1.86053 7.97487 1.86053 7.02513 2.41842 6.43934Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
ArrowDownIcon.propTypes = {
  iconColor: PropTypes.string
};
ArrowDownIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowDownIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var ArrowDownIcon$1 = withTheme(ArrowDownIcon);

export { ArrowDownIcon$1 as A };
